"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findPressReleaseById = exports.PressReleaseDetailsCard = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _basicStyledText = _interopRequireDefault(require("../../basicStyledText"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PressReleaseDetailsCard = props => {
  const {
    pressrelease
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "con-media"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "con-media__list"
  }, /*#__PURE__*/_react.default.createElement("li", {
    className: "con-schedule__list--item",
    id: "media-item-".concat(pressrelease.pressId),
    key: pressrelease.pressId
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-image-gallery"
  }, pressrelease.all_images.map(item => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "con-image-gallery__container",
      key: item.imageId
    }, /*#__PURE__*/_react.default.createElement("img", {
      className: "con-image-gallery__src",
      src: item.imageUrl,
      alt: "".concat(item.imageAlt)
    }));
  })), /*#__PURE__*/_react.default.createElement("p", {
    className: "con-text--margin-bottom-2--bold"
  }, pressrelease.title), /*#__PURE__*/_react.default.createElement("p", {
    className: "con-text--margin-bottom-2--bold"
  }, pressrelease.author), pressrelease.text.map(item => {
    return /*#__PURE__*/_react.default.createElement("p", {
      key: item.id,
      className: "con-text__s--margin-bottom-2"
    }, /*#__PURE__*/_react.default.createElement(_basicStyledText.default, {
      item: item
    }));
  }))));
};
exports.PressReleaseDetailsCard = PressReleaseDetailsCard;
PressReleaseDetailsCard.propTypes = {
  pressrelease: _propTypes.default.object
};
const findPressReleaseById = (pressreleases, id) => {
  const pressrelease = pressreleases.filter(item => {
    return item.pressId === id;
  })[0];
  if (!pressrelease) {
    throw new Error('No required data');
  }
  return pressrelease;
};
exports.findPressReleaseById = findPressReleaseById;